var map = {
	"./decidim/avatar-multiuser.png": 28397,
	"./decidim/brands/facebook.svg": 56121,
	"./decidim/brands/google.svg": 73840,
	"./decidim/brands/twitter-x.svg": 21125,
	"./decidim/cc-badge.png": 97787,
	"./decidim/decidim-logo.svg": 4559,
	"./decidim/default-avatar.svg": 67971,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 617,
	"./decidim/icons.svg": 28594,
	"./decidim/pattern.png": 52177,
	"./decidim/placeholder-card-g.svg": 58334,
	"./decidim/placeholder-card-l.svg": 38581,
	"./decidim/placeholder.jpg": 7652,
	"./decidim/remixicon.symbol.svg": 29702,
	"./decidim/vendor/social-share-button/douban.svg": 65833,
	"./decidim/vendor/social-share-button/email.svg": 82442,
	"./decidim/vendor/social-share-button/facebook.svg": 47970,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 3054,
	"./decidim/vendor/social-share-button/hacker_news.svg": 17642,
	"./decidim/vendor/social-share-button/linkedin.svg": 46552,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 1009,
	"./decidim/vendor/social-share-button/pinterest.svg": 36372,
	"./decidim/vendor/social-share-button/reddit.svg": 31982,
	"./decidim/vendor/social-share-button/telegram.svg": 69615,
	"./decidim/vendor/social-share-button/tumblr.svg": 84972,
	"./decidim/vendor/social-share-button/twitter.svg": 25279,
	"./decidim/vendor/social-share-button/vkontakte.svg": 5405,
	"./decidim/vendor/social-share-button/wechat.svg": 22304,
	"./decidim/vendor/social-share-button/whatsapp.svg": 85344,
	"./decidim/vendor/social-share-button/x.svg": 62570,
	"./decidim/vendor/social-share-button/xing.svg": 60414
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51140;